
<template>
  <v-container class="ma-0">
  <v-card class="d-flex-column mt-2 pr-2"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Λογαριασμοί</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    <v-spacer/>
      <v-btn
      color="primary"
      dark
      small
      @click="addNewBankAccount"
    >
    <v-icon>mdi-plus</v-icon> Νεος Λογαριασμος
    </v-btn>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="account">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="6"
              >
                <v-text-field
                  label="Όνομα δικαιούχου"
                  :rules="[rules.required]"
                  v-model="editedItem.Owner"
                  dense
                  ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm=8
                md=8
                xs=12
              >
                <v-text-field
                  label="IBAN*"
                  :rules="[rules.required, rules.iban]"
                  v-model="editedItem.Iban"
                  required
                  dense
                  ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm=8
                md=8
                xs=12
              >
                <v-text-field
                  label="Σχόλια"
                  v-model="editedItem.Remarks"
                  required
                  dense
                  ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Κλείσιμο
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="saveAccount"
          >
            Αποθήκευση
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



    </v-card-title>

  <v-item-group  class="ma-4 pt-4">
    <v-container fluid>
 <v-sheet class="d-flex flex-wrap bg-surface-variant justify-space-between">
        <v-col
          v-for="c in filteredAccounts"
          :key="c.Id"
          class="ma-2 pa-2"
        >
          <v-item>
            <bank-account-details :account="c" :avatar="avatar(c.Id)" :copyFunc="copyToClipboard" />
          </v-item>
        </v-col>
      </v-sheet>
    </v-container>
  </v-item-group>
  <v-snackbar v-model="snackbar" :timeout="2999">
      {{ snackText }}
    </v-snackbar>
  </v-card>

  </v-container>
</template>


<script>
import BankAccountDetails from "../../components/BankAccountDetails.vue";

export default {
  components: {
    BankAccountDetails
  },
  computed: {
    filteredAccounts () {
        return this.accounts.filter(el => el.BankCode.includes(this.search.toUpperCase()));
    },
  },
  data() {
    return {
      expanded: [],
      dialog: false,
      loading: true,
      search: "",
      snackbar: false,
      snackText: '',
      accounts: [],
      formTitle: "Νέος Τραπεζικός Λογαριασμός",
      editedItem: { },
      newItem: {
       SupplierId: this.$route.params.id,
       Owner: '',
       IBAN: null,
       Remarks: null,
      },
      supplier_id: this.$route.params.id,
      rules: {
          required: value => !!value || 'Required.',
           iban: value => {
             const pattern = /^[A-Z]{2}[0-9]{25}$/
            if (value) {
                return pattern.test(value) || 'Invalid IBAN'
            }
            return
          },
           email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (value) {
                return pattern.test(value) || 'Invalid e-mail.'
            }
            return
          },
        },
    }
  },
  async mounted() {
      try {
        this.loading = true;
        console.log(this.$route.params)
        const response = await this.$api.get('/banking/supplier/accounts/'+this.$route.params.id);
        this.accounts = response.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
    avatar (id) {
        if (id % 2) return "../assets/nina-mercado-e9YFrEBWit8-unsplash.jpg"
        return "../assets/kenny-eliason-60krlMMeWxU-unsplash.jpg"
    },
    addNewBankAccount() {
        this.editedItem = Object.assign({}, this.newItem);
        this.dialog = true;

    },
    copyToClipboard(text, label) {
      navigator.clipboard.writeText(text).then(() => {
        this.snackText = `${label} αντιγράφηκε στο πρόχειρο!`;
        this.snackbar = true;
      }).catch(err => {
        console.error('Failed to copy text: ', err);
      });
    },
     async saveAccount () {
      console.log(this.newContact);
      if (this.$refs.account.validate()) {
        this.editedItem.SupplierId = this.supplier_id
        const resp = await this.$api.post(`/banking/supplier/bank-account/`, this.editedItem);
        if (resp.status == 201) {
          this.loading = true;
        const response = await this.$api.get('/banking/supplier/accounts/'+this.$route.params.id);
        this.accounts = response.data;
        this.loading = false;
        } else
        {
          alert(resp.data.detail);
        }

        this.dialog = false;
      }
    },

  }
}
</script>
